import React, { useMemo, useContext } from "react";

import { AssigneeSelector } from "fe-shared/src/components";
import UserContext from "contexts/userContext";

import useAssignTransactions from "hooks/useAssignTransactions";

import {
  Transaction,
  TransactionStatus,
} from "fe-shared-transactions/src/types";
import { GridTransactionInternal } from "types";

const assignStatuses = [
  TransactionStatus.Submitted,
  TransactionStatus.InReview,
  TransactionStatus.Suspended,
  TransactionStatus.Reviewed,
];

interface Props {
  canAssign?: boolean;
  transaction: Transaction | GridTransactionInternal;
  assigneeName?: string;
  assigneeId?: string | number;
}

const AssigneeTransactionSelect = ({
  canAssign = true,
  transaction,
  assigneeId,
  assigneeName,
}: Props) => {
  const { transactionId, statusCode, isValidating } = transaction;
  const { userId: currentUserId } = useContext(UserContext)!;
  const [changeAssignee] = useAssignTransactions();

  const isAssignable = useMemo(
    () => canAssign && !isValidating && assignStatuses.includes(statusCode),
    [statusCode, canAssign, isValidating]
  );
  const isAssigned = !!assigneeId;

  const onChange = (newAssigneeId: string | number | null) => {
    changeAssignee({
      ids: [transactionId],
      assigneeId: newAssigneeId,
    });
  };

  return (
    <AssigneeSelector
      entityId={transactionId.toString()}
      isAssignable={isAssignable}
      isUnAssignable={false}
      loadOnlyActive={true}
      isAssigned={isAssigned}
      currentUserId={currentUserId}
      assigneeId={assigneeId}
      assigneeName={assigneeName}
      onChange={onChange}
    />
  );
};

export default AssigneeTransactionSelect;
